import { useCall } from "@/hooks/useCall/useCall";
import { useGetLine } from "@/hooks/useGetLine/useGetLine";
import { useTrack } from "@/hooks/useTrack/useTrack";

export function useTracking() {
  const { track } = useTrack();

  const { call } = useCall();
  const { lineId } = useGetLine();

  const onClick = () => {
    track("conversation_info_tag_updated", {
      call_uuid: call?.uuid,
      number_id: lineId,
      // Has to be a delete in this case.
      update_type: "deleted",
    });
  };

  return { onClick };
}
